import { inject, Service } from "@angular/core";

import { IntpMilestoneModel, MainResponseModel } from "../models";
import { MainService } from ".";

@Service()
export class IntpMilestonesApiService {
  private _mainService = inject(MainService);

  public getById(id: number) {
    return this._mainService.sendRequest<MainResponseModel<IntpMilestoneModel>>({
      method: "GET",
      url: `international-project-milestone/getById/${id}`,
    });
  }

  public updateMilestone(isFinish: boolean = true, data: IntpMilestoneModel) {
    const url = `international-project-milestone/update?isFinish=${isFinish}`;

    return this._mainService.sendRequest<MainResponseModel>({
      method: "PUT",
      url,
      data: data,
    });
  }

  public getProjectMilestones(projectId: number) {
    return this._mainService.sendRequest<MainResponseModel<IntpMilestoneModel[]>>({
      method: "GET",
      url: `international-project-milestone/getMilestoneValuesByInternationalProjectId/${projectId}`,
    });
  }
}
